import { ComponentPropsWithoutRef, forwardRef } from 'react';
import cns from 'classnames';
import 'keen-slider/keen-slider.min.css';
import { AutoSlidePlugin } from './AutoSlidePlugin';
const Slider = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>((props, forwardedRef) => {
  const {
    className,
    ...rest
  } = props;
  return <div ref={forwardedRef} className={cns('keen-slider', className)} {...rest} />;
});
const Slide = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>((props, forwardedRef) => {
  const {
    className,
    ...rest
  } = props;
  return <div ref={forwardedRef} className={cns('keen-slider__slide', className)} {...rest} />;
});
export const Carousel = Object.assign(Slider, {
  Slide,
  AutoSlidePlugin
});